import Faq from "./Faq";
import Danhgia from "./Danhgia";
import Clonecontact from "./Clonecontact";
import Cloneheader from "./Cloneheader";
import Cloneloiich from "./Cloneloiich";
import Quytrinh from "./Quytrinh";
import Clonevitri from "./Clonevitri";

export default function Clonehome() {
  return (
    <div>
      <Cloneheader />
      <Quytrinh />
      <Cloneloiich />
      <Clonevitri />
      <Clonecontact />
    </div>
  );
}
